import request from "@/utils/request";

export default function agentUnbindWeChatPush() {
    return request({
        url: `/user/agent/agentUnbindWeChatPush`,
        method: 'post',
    })
}
